module.exports = __webpack_public_path__ + "img/add-circle-outline.06213f91.svg";